import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "add-vat-tu-items-form" }
const _hoisted_2 = {
  class: "add-vat-tu-items-form__search",
  "data-autofocus": ""
}
const _hoisted_3 = { class: "text-danger" }
const _hoisted_4 = { class: "add-vat-tu-items-form__qty" }
const _hoisted_5 = {
  key: 0,
  class: "add-vat-tu-items-form__price"
}
const _hoisted_6 = { class: "add-vat-tu-items-form__action" }
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = { class: "table-index-cell" }
const _hoisted_9 = { class: "table-index-cell__order" }
const _hoisted_10 = { class: "table-index-cell__id" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0 justify-center" }, "ĐVT", -1)
const _hoisted_12 = { class: "d-flex align-items-center mb-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0 break-word justify-center" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "break-word" }, "Số lượng")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Đơn giá")
], -1)
const _hoisted_15 = {
  key: 1,
  class: "text-end mb-0"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0 break-word" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "break-word" }, "Thành tiền:")
], -1)
const _hoisted_17 = { class: "text-end mb-0 break-word" }
const _hoisted_18 = { class: "break-word" }
const _hoisted_19 = { class: "d-flex justify-content-center flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_QuantityInputCustom = _resolveComponent("QuantityInputCustom")!
  const _component_CurrencyInputCustom = _resolveComponent("CurrencyInputCustom")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_WordBreakColumn = _resolveComponent("WordBreakColumn")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_FormModalShell = _resolveComponent("FormModalShell")!
  const _directive_dialog_auto_focus = _resolveDirective("dialog-auto-focus")!

  return (_openBlock(), _createBlock(_component_FormModalShell, {
    "is-display": _ctx.isOpen,
    title: _ctx.titleDisplay,
    size: "xl",
    onClose: _ctx.onClose
  }, {
    footer: _withCtx(() => [
      (_ctx.isChange)
        ? (_openBlock(), _createBlock(_component_ButtonCustom, {
            key: 0,
            "button-type": _ctx.ButtonsType.SAVE,
            "color-type": _ctx.ButtonTypeColors.SUCCESS,
            "is-disabled": _ctx.isProcessing,
            onClick: _ctx.submit
          }, {
            "button-label": _withCtx(() => [
              _createTextVNode(" Lưu ")
            ]),
            _: 1
          }, 8, ["button-type", "color-type", "is-disabled", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.CANCEL,
        "color-type": _ctx.ButtonTypeColors.DANGER,
        "is-disabled": _ctx.isProcessing,
        onClick: _ctx.onClose
      }, {
        "button-label": _withCtx(() => [
          _createTextVNode(" Đóng ")
        ]),
        _: 1
      }, 8, ["button-type", "color-type", "is-disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_autocomplete, {
              modelValue: _ctx.tenVatTu,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tenVatTu) = $event)),
              ref: "vatTuInput",
              class: _normalizeClass(["w-100", { 'vat-tu-input-class-no-result': !_ctx.isVatTuItemsAvailable }]),
              clearable: "",
              placeholder: "Tìm kiếm vật tư",
              "value-key": "ten_vat_tu",
              "trigger-on-focus": false,
              "fetch-suggestions": _ctx.queryVatTu,
              "highlight-first-item": true,
              disabled: _ctx.isProcessing,
              onSelect: _ctx.onSelectVatTu,
              onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select()))
            }, {
              default: _withCtx(({ item }) => [
                _createElementVNode("span", null, [
                  _createElementVNode("strong", null, _toDisplayString(item.ma_vat_tu) + " - ", 1)
                ]),
                _createElementVNode("span", null, _toDisplayString(item.ten_vat_tu), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "class", "fetch-suggestions", "disabled", "onSelect"]),
            _withDirectives(_createElementVNode("span", _hoisted_3, "Không có dữ liệu", 512), [
              [_vShow, !_ctx.isVatTuItemsAvailable]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_QuantityInputCustom, {
              ref: "soLuongInput",
              modelValue: _ctx.so_luong,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.so_luong) = $event)),
              "class-str": "w-100",
              min: 0.01,
              placeholder: "Số lượng",
              "is-disabled": _ctx.vatTuId === 0 || _ctx.isProcessing
            }, null, 8, ["modelValue", "is-disabled"])
          ]),
          (_ctx.isForHopDong || _ctx.isForPhieuNhapKho)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_CurrencyInputCustom, {
                  modelValue: _ctx.don_gia,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.don_gia) = $event)),
                  "class-str": "w-100",
                  "is-disabled": _ctx.isDonGiaInputDisabled || _ctx.isProcessing,
                  min: _ctx.useFor === _ctx.AddVatTuItemsFor.PHIEU_NHAP_LE ? 0 : 0.01,
                  placeholder: "Đơn giá",
                  onInput: _ctx.formatDonGia
                }, null, 8, ["modelValue", "is-disabled", "min", "onInput"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ButtonCustom, {
              classes: `rounded-none m-0`,
              "button-type": _ctx.ButtonsType.ADD,
              "is-disabled": _ctx.isAddButtonDisable || _ctx.isProcessing,
              "tooltip-message": "Thêm vật tư",
              onClick: _ctx.onAddVatTu
            }, null, 8, ["button-type", "is-disabled", "onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_table, {
            class: "add-vat-tu-items-table",
            border: true,
            "cell-class-name": _ctx.isTextDangerColumn,
            data: _ctx.selectedVatTuItems,
            "empty-text": _ctx.emptyText,
            "max-height": "800",
            size: "medium",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "STT",
                width: _ctx.columnWidths.stt
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(scope.$index + 1), 1),
                    _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(scope.row.id) + ")", 1)
                  ])
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_WordBreakColumn, {
                "min-width": String(_ctx.columnWidths.ten),
                "header-title": "Tên",
                property: "ten_vat_tu"
              }, null, 8, ["min-width"]),
              _createVNode(_component_WordBreakColumn, {
                width: String(_ctx.columnWidths.ma),
                "header-title": "Mã",
                property: "ma_vat_tu"
              }, null, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.columnWidths.dvt
              }, {
                header: _withCtx(() => [
                  _hoisted_11
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(scope.row.don_vi_tinh ? scope.row.don_vi_tinh : "-"), 1)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                label: "Thu hồi",
                width: _ctx.columnWidths.thuHoi
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_checkbox, {
                    "model-value": !!scope.row.thu_hoi,
                    disabled: ""
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                label: "C/ty quản lý",
                width: _ctx.columnWidths.congTyQuanLy,
                "class-name": "add-vat-tu-items-table__before-fixed-col",
                "header-cell-class-name": "add-vat-tu-items-table__before-fixed-col"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_checkbox, {
                    "model-value": !!scope.row.cong_ty_duyet,
                    disabled: ""
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.columnWidths.soLuong,
                fixed: "right",
                "class-name": "add-vat-tu-items-table__first-fixed-col amount-cell",
                "header-cell-class-name": "add-vat-tu-items-table__first-fixed-col",
                "header-align": "center"
              }, {
                header: _withCtx(() => [
                  _hoisted_13
                ]),
                default: _withCtx((scope) => [
                  _createVNode(_component_QuantityInputCustom, {
                    modelValue: scope.row.so_luong,
                    "onUpdate:modelValue": ($event: any) => ((scope.row.so_luong) = $event),
                    "class-str": "w-100",
                    min: 0.01,
                    placeholder: "Số lượng",
                    "is-disabled": _ctx.isProcessing
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "is-disabled"])
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.columnWidths.donGia,
                fixed: "right",
                "header-align": "center"
              }, {
                header: _withCtx(() => [
                  _hoisted_14
                ]),
                default: _withCtx((scope) => [
                  (_ctx.isForHopDong || _ctx.isForPhieuNhapKho)
                    ? (_openBlock(), _createBlock(_component_CurrencyInputCustom, {
                        key: 0,
                        modelValue: scope.row.don_gia,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.don_gia) = $event),
                        "class-str": "w-100",
                        placeholder: "Đơn giá",
                        min: _ctx.minDonGia,
                        "is-disabled": _ctx.isProcessing
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "is-disabled"]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_15, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.formatUnitPrice(scope.row.don_gia)), 1)
                      ]))
                ]),
                _: 1
              }, 8, ["width"]),
              (_ctx.isForHopDong || _ctx.isForPhieuNhapKho)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    width: _ctx.columnWidths.thanhTien,
                    fixed: "right"
                  }, {
                    header: _withCtx(() => [
                      _hoisted_16
                    ]),
                    default: _withCtx((scope) => [
                      _createElementVNode("p", _hoisted_17, [
                        _createElementVNode("strong", _hoisted_18, _toDisplayString(!!scope.row.don_gia
                      ? _ctx.formatAmount(
                          _ctx.calcLineAmount(
                            parseFloat(scope.row.don_gia),
                            +scope.row.so_luong
                          )
                        )
                      : _ctx.formatAmount(0)), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["width"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, {
                width: _ctx.columnWidths.actions,
                fixed: "right",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_ButtonCustom, {
                      "button-type": _ctx.ButtonsType.TRASH,
                      "color-type": _ctx.ButtonTypeColors.DANGER,
                      "is-disabled": _ctx.isProcessing,
                      "tooltip-message": "Xoá v/tư đã thêm",
                      onClick: ($event: any) => (_ctx.onDeleteVatTu(scope.row.id))
                    }, null, 8, ["button-type", "color-type", "is-disabled", "onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["width"])
            ]),
            _: 1
          }, 8, ["cell-class-name", "data", "empty-text"])
        ])
      ])), [
        [_directive_dialog_auto_focus, _ctx.isOpen]
      ])
    ]),
    _: 1
  }, 8, ["is-display", "title", "onClose"]))
}